var getStateObj = function(){
    return (localStorage.getItem('state')) ? JSON.parse(localStorage.getItem('state')) : {};
};

var setStateObj = function(state){
    localStorage.setItem('state', JSON.stringify(state));
};

var setStateParam = function(param, value){
    var state = getStateObj();
    state[param] = value;
    setStateObj(state);
};

var getStateParam = function(param){
    var state = getStateObj();
    return state[param];
};

var deleteStateParam = function(param){
    var state = getStateObj();
    delete state[param];
    setStateObj(state);
};

(function () {
    'use strict';
    var selectTabFromHash = function(){
        var hash = window.location.hash;
        if (hash && $('a[data-toggle="tab"][href="'+hash+'"]')) {
            $('a[data-toggle="tab"][href="'+hash+'"]').tab('show');
        }else if (getStateParam('home_tab')) {
            $('a[data-toggle="tab"][href="'+getStateParam('home_tab')+'"]').tab('show');
        }
    };

    // tab state
    $(document).ready(function(){
        selectTabFromHash();
        $(window).on('hashchange', function() {
            selectTabFromHash();
        });
        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            var selectedTab = e.target.getAttribute('href');
            if(history.pushState) {
              history.pushState(null, null, selectedTab);
            }
            else {
              window.location.hash = selectedTab;
            }
            setStateParam('home_tab', selectedTab);
            var hash = window.location.hash;
            // should resize table to fit tab, but not working.
            if ($('.tab-pane'+hash+' .datatable').length > 0) {
              var dataTable = $('.tab-pane'+hash+' .datatable').dataTable();
              dataTable.fnAdjustColumnSizing();
            }
        });
    });
}());